module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 marker-details"
  }, [_c('h3', [_c('span', {
    staticClass: "highlight"
  }, [_vm._v(_vm._s(_vm.$t("marker.event")) + ":")]), _vm._v("\n      " + _vm._s(_vm.getLocalizedProp(_vm.marker.name)) + "\n      "), _c('dropdown', {
    staticClass: "event-options"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-option-horizontal clickable options-trigger",
    attrs: {
      "slot": "trigger"
    },
    slot: "trigger"
  }), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu show",
    attrs: {
      "slot": "options"
    },
    slot: "options"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: ("/marker/" + (_vm.marker.id) + "/edit")
      }
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-pencil"
  }), _vm._v("\n              " + _vm._s(_vm.$t('marker.edit')) + "\n            ")])], 1), _vm._v(" "), _c('li', {
    class: {
      'disabled': !_vm.hasStarted
    }
  }, [_c('a', _vm._g({
    attrs: {
      "href": "#"
    }
  }, _vm.hasStarted ? {
    click: _vm.downloadCsv
  } : {
    click: function (e) { return e.stopPropagation(); }
  }), [_c('span', {
    staticClass: "glyphicon glyphicon-download-alt"
  }), _vm._v("\n              " + _vm._s(_vm.$t('marker.download_csv')) + "\n            ")])]), _vm._v(" "), _c('li', [_c('ftp-sync-button', {
    attrs: {
      "marker-id": _vm.marker.id
    }
  })], 1)])])], 1), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "highlight"
  }, [_vm._v(_vm._s(_vm.$t("marker.start_date")) + ":")]), _vm._v(" "), _c('date', {
    attrs: {
      "value": _vm.marker.starts_at
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "separator"
  }, [_vm._v("•")]), _vm._v(" "), _c('span', {
    staticClass: "highlight"
  }, [_vm._v(_vm._s(_vm.$t("marker.end_date")) + ":")]), _vm._v(" "), _c('date', {
    attrs: {
      "value": _vm.marker.ends_at
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-133ae8c9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/marker/MarkerDetails.vue
// module id = 1021
// module chunks = 1